export default {
  name: "restore",
  components: {},
  props: [],
  data() {
    return {
      librariesTrash: {},
      item: {},
      errors: {},
      btn_submit: false
    };
  },
  computed: {
    data() {
      return this.$store.getters["Library/getListTrash"];
    }
  },
  mounted() {
    this.$loading.start();
    Promise.all([this.$store.dispatch("Library/getListTrash", {})])
      .then(res => {
        this.$loading.complete();
      })
      .catch(errors => {
        this.$loading.fail();
      });
  },
  methods: {
    detailImageTrash(item) {
      this.item = item;
      this.$refs.DetailImageTrash.show();
    },
    restore() {
      this.btn_submit = true;
      this.$loading.start();
      this.$store
        .dispatch("Library/restore", {
          id: this.item.id
        })
        .then(res => {
          this.$refs.DetailImageTrash.hide();
          this.item = {};
          this.btn_submit = false;
          this.$loading.complete();
        })
        .catch(errors => {
          this.$loading.complete();
        });
    },
    remove() {
      this.btn_submit = true;
      this.$loading.start();
      this.$store
        .dispatch("Library/destroyPermanently", {
          id: this.item.id
        })
        .then(res => {
          this.$refs.DetailImageTrash.hide();
          this.item = {};
          this.btn_submit = false;
          this.$loading.complete();
        })
        .catch(errors => {
          this.$loading.complete();
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/library/restore/restore.js